import React from 'react';
import Router from './Router';
import './App.css';

const App = () => (    
  <div className="App">
    <Router />      
  </div>
);

export default App;
